import type { FeedbackStore } from './interfaces'
import type { ExperienceIssues, ConnectionIssues } from '@ts-feedback/enums'

import { getStepOrder } from '@stores/feedback/getters'

import { FeedbackStep } from './enums'

export const actions = {
  setReady (this: FeedbackStore, payload: FeedbackStore['ready']): void {
    this.ready = payload
  },
  setBooking (this: FeedbackStore, payload: FeedbackStore['booking']): void {
    this.booking = payload
  },
  setDiscipline (this: FeedbackStore, payload: FeedbackStore['discipline']): void {
    this.discipline = payload
  },
  setOptions (this: FeedbackStore, payload: FeedbackStore['options']): void {
    this.options = payload
  },
  setStep (this: FeedbackStore, payload: FeedbackStore['step']): void {
    this.step = payload
  },

  isStep (this: FeedbackStore, step: FeedbackStep): boolean {
    return this.step === step
  },

  setRole (this: FeedbackStore, payload: FeedbackStore['role']): void {
    this.role = payload
  },

  setRating (this: FeedbackStore, payload: FeedbackStore['rating']): void {
    this.rating = payload
  },

  setClassroomRating (this: FeedbackStore, payload: FeedbackStore['classroomRating']): void {
    this.classroomRating = payload
  },

  setSurveyType (this: FeedbackStore, payload: FeedbackStore['surveyType']): void {
    this.surveyType = payload
  },

  setTutorTransitionRating (this: FeedbackStore, payload: FeedbackStore['tutorTransitionRating']): void {
    this.tutorTransitionRating = payload
  },

  setDetailedFeedback (this: FeedbackStore, payload: FeedbackStore['detailedFeedback']): void {
    this.detailedFeedback = payload
  },

  setCategory (this: FeedbackStore, payload: FeedbackStore['category']): void {
    this.category = payload
    this.selectedIssues = []
    this.commentError = false
  },

  toggleIssue (this: FeedbackStore, payload: ExperienceIssues | ConnectionIssues): void {
    const index = this.selectedIssues.indexOf(payload)

    if (index === -1) {
      this.selectedIssues.push(payload)
    } else {
      this.selectedIssues.splice(index, 1)
      this.commentError = false
    }
  },

  setComment (this: FeedbackStore, payload: FeedbackStore['comment']): void {
    this.comment = payload
    this.commentError = false
  },

  setCommentError (this: FeedbackStore, payload: FeedbackStore['commentError']): void {
    this.commentError = payload
  },

  setAdditionalPractice (this: FeedbackStore, payload: FeedbackStore['additionalPractice']): void {
    this.additionalPractice = payload
  },

  setNextStep (this: FeedbackStore): void {
    const steps = getStepOrder(this)
    const currentIndex = steps.indexOf(this.step)
    const nextIndex = currentIndex + 1

    if (nextIndex < steps.length) {
      this.step = steps[nextIndex]!
    }
  },

  setPrevStep (this: FeedbackStore): void {
    const steps = getStepOrder(this)
    const currentIndex = steps.indexOf(this.step)
    const prevIndex = currentIndex - 1

    if (prevIndex >= 0) {
      this.step = steps[prevIndex]!
    }
  },

  reset (this: FeedbackStore): void {
    this.step = FeedbackStep.Role
    this.role = null
    this.rating = null
    this.classroomRating = null
    this.tutorTransitionRating = null
    this.detailedFeedback = ''
    this.category = null
    this.selectedIssues = []
    this.comment = ''
    this.commentError = false
    this.additionalPractice = null
  },
}
